function startTimer(startTimerAt) { 
    var timerDiv = document.getElementById('timer') 
    timer = setInterval(() => {
        timeLeft -= 1
        timerDiv.innerHTML = timeLeft
        if (timeLeft == 0) {
            clearInterval(timer)
            stopGame()
        }

    }, 1000);
}